import React from "react";
import { Panel, Label } from "lib/components";
import { getCompanySettings } from "lib/util";
import { ReturnHomeButton } from "portal/customer/ReturnHomeButton";

export function OrderConfirmationHeader(props) {
  return (
    <Panel fillRow>
      <Panel fillRow noRowBreak>
        <Label caption="Order Confirmation" look="primary12" />
        <Label field="hold_warning" look="warningBold6" />
        <Label caption={getCompanySettings().order_submit_ok} look="subtle2" />
      </Panel>
      <ReturnHomeButton />
    </Panel>
  );
}